<template>
  <v-card tile :color="itemAction.color" class="elevation-2 mx-1" :min-height="itemAction.height">
          <div class="d-flex flex-no-wrap justify-space-between">
            <v-avatar class="ma-3" size="130" tile>
              <v-progress-circular v-if="showData" indeterminate color="white"></v-progress-circular>
              <span v-else class="white--text text-h2 font-weight-bold">{{ amount }}</span>
            </v-avatar>
            <div>
              <v-card-title class="title">{{title}}</v-card-title>
              <v-card-actions>
                <v-btn class="ml-2 font-weight-bold" @click="send" outlined rounded small dark> VER RESULTADO</v-btn>
              </v-card-actions>
            </div>
          </div>
  </v-card>
</template>
<script>
import axios from 'axios'
import { HeaderGral } from '@/store/modules/config'
export default {
  props: ['itemAction', 'onSuccess'],
  data: () => ({
    amount: 0,
    title: '--- Nombre del indicador --- ',
    showData: true
  }),
  created () {
    if (this.itemAction.url) {
      this.getDinamicData(this.itemAction.url)
    }
  },
  methods: {
    getDinamicData (url) {
      const header = HeaderGral()
      axios.get(url, header).then((response) => {
        this.amount = response.data.amount
        this.title = response.data.title
        this.showData = false
      }).catch((error) => {
        console.error('Error:', error)
      })
    },
    send () {
      this.onSuccess(this.itemAction.action)
    }
  }
}
</script>

<style scoped>
.scroll-box {
  min-height: 300px;
  max-height: 1000px;
  width: 100%;
  overflow-x: auto;
}
</style>
